/**
 * 庫存標籤（**單一位置**：值 → 顏色 ＋ i18n key）
 *
 * ⚠️ 呢啲值係**後端契約**（`@coeldery/stock-ledger` 嘅受控位置 ＋ `stock_movements.type`）
 *    —— 前端**唔准**自己發明新值；加值要同時改模組＋migration＋呢度。
 */
import { useTranslation } from 'react-i18next';
import { badge } from '@coeldery/ui-kit';

/** 基本位置（另有 `roadshow:<單號>`／`store:<code>` —— 呢啲直接顯示原文） */
export const BASE_LOCATIONS = ['warehouse', 'damaged', 'office', 'supplier', 'written_off'] as const;

const LOC_LABEL: Record<string, string> = {
  warehouse: 'loc.warehouse',
  damaged: 'loc.damaged',
  office: 'loc.office',
  supplier: 'loc.supplier',
  written_off: 'loc.writtenOff',
};

const LOC_TONE: Record<string, 'ok' | 'off' | 'warn' | 'sponsored' | 'info'> = {
  warehouse: 'ok',
  damaged: 'warn',
  supplier: 'off',
  written_off: 'off',
};

/** i18n key（基本位置才有；`roadshow:*`／`store:*` → null ＝ 顯示原文） */
export const locationLabelKey = (location: string): string | null => LOC_LABEL[location] ?? null;

export function LocationChip({ location }: { location: string }) {
  const { t } = useTranslation();
  const key = locationLabelKey(location);
  return <span style={badge(LOC_TONE[location] ?? 'info')}>{key ? t(key) : location}</span>;
}

/** 移動類型（契約：`IN｜OUT｜SALE｜TRANSFER｜ADJUST`） */
export const MOVEMENT_TYPES = ['IN', 'OUT', 'SALE', 'TRANSFER', 'ADJUST'] as const;

const TYPE_LABEL: Record<string, string> = {
  IN: 'mov.typeIn',
  OUT: 'mov.typeOut',
  SALE: 'mov.typeSale',
  TRANSFER: 'mov.typeTransfer',
  ADJUST: 'mov.typeAdjust',
};

const TYPE_TONE: Record<string, 'ok' | 'off' | 'warn' | 'sponsored' | 'info'> = {
  IN: 'ok',
  OUT: 'info',
  SALE: 'sponsored',
  ADJUST: 'warn',
};

export const movementTypeLabelKey = (type: string): string => TYPE_LABEL[type] ?? 'mov.typeAdjust';

/** 篩選器選項（由一個來源砌，唔准各自抄） */
export const movementTypeOptions = MOVEMENT_TYPES.map((v) => ({ value: v as string, labelKey: TYPE_LABEL[v]! }));

export function MovementTypeChip({ type }: { type: string }) {
  const { t } = useTranslation();
  return <span style={badge(TYPE_TONE[type] ?? 'info')}>{t(movementTypeLabelKey(type))}</span>;
}
